export function interopRequireDefault(defaultImport) {
  const asAny = defaultImport;
  // istanbul ignore next
  return asAny.__esModule ? asAny.default : defaultImport;
}
//# sourceMappingURL=interopRequireDefault.mjs.map